import React, { useEffect, useRef, useState } from "react";
import { Mic, Pause, Play, RotateCcw } from "lucide-react";
import { speak } from "@/context/A11yContext";

const pill = "flex shrink-0 items-center gap-1 rounded-full border px-2.5 py-1 text-xs transition-colors hover:border-primary hover:text-primary";

// Listen → Pause → Resume on each tap; "From start" restarts.
export const ListenButton = ({ id, text, label, rate = 1 }) => {
  const [state, setState] = useState("idle");
  const mine = useRef(false);
  const run = useRef(0);
  useEffect(() => {
    const onOther = (e) => { if (e.detail !== id) { mine.current = false; setState("idle"); } };
    window.addEventListener("jt-speak", onOther);
    return () => { window.removeEventListener("jt-speak", onOther); if (mine.current) window.speechSynthesis?.cancel(); };
  }, [id]);
  const start = () => {
    mine.current = true;
    const token = (run.current += 1);
    if (speak(text, rate, { id, onEnd: () => { if (mine.current && run.current === token) { mine.current = false; setState("idle"); } } })) setState("playing");
  };
  const toggle = () => {
    if (state === "idle") return start();
    if (state === "playing") { window.speechSynthesis.pause(); setState("paused"); }
    else { window.speechSynthesis.resume(); setState("playing"); }
  };
  const Icon = state === "playing" ? Pause : state === "paused" ? Play : Mic;
  return (
    <div className="mt-1 flex shrink-0 items-center gap-1.5">
      <button onClick={toggle} aria-label={`${state === "playing" ? "Pause" : state === "paused" ? "Resume" : "Read aloud"}: ${label}`} data-testid={`listen-${id}`}
        className={`${pill} ${state === "idle" ? "border-border text-muted-foreground" : "border-primary text-primary"}`}>
        <Icon size={12} /> {state === "playing" ? "Pause" : state === "paused" ? "Resume" : "Listen"}
      </button>
      {state !== "idle" && (
        <button onClick={start} aria-label={`Read from the start: ${label}`} data-testid={`listen-restart-${id}`} className={`${pill} border-border text-muted-foreground`}>
          <RotateCcw size={12} /> From start
        </button>
      )}
    </div>
  );
};
